import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import Tooltip from 'LuxKit/Tooltip'

interface Props {
  guideType: string
}

function TourV2GuideTypeToolTipInfo(props: Props) {
  const { guideType } = props
  const intl = useIntl()

  const guideDescription = useMemo(() => {
    switch (guideType) {
      case 'Fully Guided Tour':
        return intl.formatMessage({
          id: 'qjXfvlYqaL',
          defaultMessage: 'You’ll have a tour director and driver with you throughout the entire trip, from start to finish. There might be different tour directors for different regions. If your tour includes multiple countries any internal flights included will be unescorted.',
          description: 'Tooltip description explaining what a Fully Guided Tour includes',
        })
      case 'Partially Guided Tour':
        return intl.formatMessage({
          id: 'MVjqbg2FZB',
          defaultMessage: 'A tour with a driver and local guides at specific locations or portions of the trip.',
          description: 'Tooltip description explaining what a Partially Guided Tour includes',
        })
      case 'Self-Guided Tour':
        return intl.formatMessage({
          id: '8HQYPnyxdA',
          defaultMessage: 'A tour where travellers explore independently without a dedicated guide.',
          description: 'Tooltip description explaining what a Self-Guided Tour includes',
        })
      default:
        return ''
    }
  }, [guideType, intl])

  return (
    <Tooltip
      description={guideDescription}
    >
      <LineInfoCircleIcon colour="neutral-two" />
    </Tooltip>
  )
}

export default TourV2GuideTypeToolTipInfo
